export const LECTURE_TYPE = {
    VIDEO : 0,
    EMBEDPAGE : 1,
    ADDITIONAL : 2,
    DOWNLOAD: 3,
    DOCUMENTATION: 4,
    SURVEY: 5
};